interface NamedPerson {
  id?: string;
  firstName?: string;
  lastName?: string;
  isFake?: boolean;
  external?: boolean;
}

const normalizeNamePart = (part: string | null | undefined): string => {
  if (!part) {
    return '';
  }
  const s = String(part).trim();
  if (s === 'null' || s === 'undefined') {
    return '';
  }
  return s;
};

const formatNameParts = (firstName?: string | null, lastName?: string | null, reverse = false): string => {
  const first = normalizeNamePart(firstName);
  const last = normalizeNamePart(lastName);
  return (reverse ? [last, first] : [first, last]).filter(Boolean).join(' ');
};

export const formatName = (person: NamedPerson | undefined): string => {
  if (isFakeNonExternalCustomer(person)) {
    return '';
  }

  return formatNameParts(person?.firstName, person?.lastName, false);
};

export const formatNameReverse = (person: NamedPerson | undefined): string => {
  if (isFakeNonExternalCustomer(person)) {
    return '';
  }

  return formatNameParts(person?.firstName, person?.lastName, true);
};

export const isFakeCustomer = (customer: NamedPerson | undefined): boolean => customer?.isFake ?? false;

export const isFakeNonExternalCustomer = (customer: NamedPerson | undefined): boolean =>
  isFakeCustomer(customer) && !customer?.external;
